import { render } from "./DaysCounter.vue?vue&type=template&id=3450763c&scoped=true&ts=true"
import script from "./DaysCounter.vue?vue&type=script&lang=ts"
export * from "./DaysCounter.vue?vue&type=script&lang=ts"

import "./DaysCounter.vue?vue&type=style&index=0&id=3450763c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3450763c"]])

export default __exports__